import * as React from "react";
const SvgIconAdvanceSearchreact = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" viewBox="0 0 20 20" {...props}><g clipPath="url(#icon-advance-search_react_svg__a)"><path d="M3 2h14.933v7.533H15.8v-5.4H5.133V16.8H9.4v2.133H3z" style={{
      fillOpacity: 1
    }} /><path d="M9 10.467V12.6H6.2v-2.133zM14.733 7.267V9.4H6.2V7.267z" style={{
      fill: "currentColor",
      fillOpacity: 1
    }} /><path fillRule="evenodd" d="M15 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m.221 3.049a3.5 3.5 0 1 1 1.389-1.44L18 17.5l-1.414 1.414z" clipRule="evenodd" style={{
      fill: "currentColor",
      fillOpacity: 1
    }} /></g><defs><clipPath id="icon-advance-search_react_svg__a"><path d="M0 0h20v20H0z" /></clipPath></defs></svg>;
export default SvgIconAdvanceSearchreact;